import { addWithoutSingleData, sortTimeListFunc } from '@/pages/opinion/utils';
import { useEffect, useState } from 'react';

/**
 * TODO: 其他系统使用
 * 获取统计图数据Map对象
 * @param param0
 * @returns
 */
export default function usePcConsoleTimelineChart({
  platformData,
  filterParams,
  seriesDataKeys,
}: any) {
  const [chartMap, setChartMap] = useState<{ [key: string]: Array<any> }>({});
  const [chartNoDataMap, setChartNoDataMap] = useState<boolean>(false);
  useEffect(() => {
    const { list, timeline_of_end_time, timeline_of_start_time } =
      platformData || { list: {} };
    const chartTimeline: any = {};
    const noData: any = {};
    const dataKey = (seriesDataKeys || []).map((val) => val.key);
    for (const key in list) {
      const sortedList = (list?.[key] || []).sort(sortTimeListFunc('time'));
      const value = addWithoutSingleData(
        timeline_of_start_time,
        timeline_of_end_time,
        filterParams.date_type,
        sortedList,
        {
          review: 0,
          score: 0,
          key,
        },
        'time',
      );
      if (dataKey?.length > 0) {
        if (dataKey?.includes(key)) {
          noData[key] = value.every(
            (item) => item.review === 0 && item.score === 0,
          );
        }
      } else {
        noData[key] = value.every(
          (item) => item.review === 0 && item.score === 0,
        );
      }

      chartTimeline[key] = value;
    }
    setChartNoDataMap(Object.values(noData).every((item) => item));
    setChartMap(chartTimeline);
  }, [platformData, filterParams, seriesDataKeys]);

  return { chartMap, chartNoDataMap };
}
